import React from "react";
import {Navigation} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import {isNotEmpty} from "../../utils/CommonUtil.ts";
import {Image} from "react-bootstrap";
import {url} from "../../utils/UrlsUtil.ts";
import {img} from "../../utils/ImageUtil.ts";
import "../../../style/common/components/swiper/design_template_swiper.scss";

interface DesignTemplateSwiperProps {
    templateList: GoodsOptionDetailDto[];
    selectedTemplateDto?: GoodsOptionDetailDto | null;
    onSelectedChange?: (dto: GoodsOptionDetailDto) => void;
    addClassName?: string | null;
}

const DesignTemplateSwiper:React.FC<DesignTemplateSwiperProps> = (
    {
        templateList = [],
        selectedTemplateDto = null,
        onSelectedChange = () => {},
        addClassName = "",
    }
) => {
    if (templateList && templateList.length > 0) {
        return(
            <Swiper spaceBetween={20}
                    slidesPerView={2}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    modules={[Navigation]}
                    breakpoints={{
                        768: {slidesPerView: 3}
                    }}
                    className={`design-template-swiper ${isNotEmpty(addClassName)? addClassName : ''}`}
            >
                {templateList.map( ((templateDto, idx) => (<SwiperSlide key={`slide_design_template_item_${idx}`}>
                    <dl className={`design-template-item${ (selectedTemplateDto && templateDto.option_detail_id === selectedTemplateDto.option_detail_id) ? ' selected-item' : ''}`}
                        onClick={() => {onSelectedChange(templateDto)}}
                    >
                        <dt><Image src={img(templateDto.image_path01)} fluid={true}></Image></dt>
                        <dd>{templateDto.option_detail_name}</dd>
                    </dl>
                </SwiperSlide>)))}
                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>
            </Swiper>
        );
    }else {
        return <></>;
    }

}
export default DesignTemplateSwiper;
